let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("54fgZ")).then(() => parcelRequire('hyMs9'));